/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { PersonStammMasterListEntryMeta } from './personStammMasterListEntryMeta';


export interface CapititelEntryMeta { 
    titelIndex?: number;
    mTitelIndex?: FieldMetaData;
    anmelder?: Array<PersonStammMasterListEntryMeta>;
    mAnmelder?: FieldMetaData;
    eintragDatum?: Date;
    mEintragDatum?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    titelJahr?: number;
    mTitelJahr?: FieldMetaData;
    erstellAmtNummer?: number;
    mErstellAmtNummer?: FieldMetaData;
    pfandtitelStatus?: CapititelEntryMeta.PfandtitelStatusEnum;
    mPfandtitelStatus?: FieldMetaData;
    titelName?: string;
    mTitelName?: FieldMetaData;
    austragDatum?: Date;
    mAustragDatum?: FieldMetaData;
}
export namespace CapititelEntryMeta {
    export type PfandtitelStatusEnum = 'UNBEKANNT' | 'EINGETRAGEN' | 'AUSGETRAGEN' | 'ERSTELLT';
    export const PfandtitelStatusEnum = {
        UNBEKANNT: 'UNBEKANNT' as PfandtitelStatusEnum,
        EINGETRAGEN: 'EINGETRAGEN' as PfandtitelStatusEnum,
        AUSGETRAGEN: 'AUSGETRAGEN' as PfandtitelStatusEnum,
        ERSTELLT: 'ERSTELLT' as PfandtitelStatusEnum
    };
}


